import { render } from "./ProspectusItem.vue?vue&type=template&id=5d4d82ca"
import script from "./ProspectusItem.vue?vue&type=script&lang=js"
export * from "./ProspectusItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\FinanssivalvontaCMS12\\Finanssivalvonta.web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__